export const config = {
    IS_PROD: ~~process.env.IS_PROD === 1,
};
//# sourceMappingURL=config.js.map